import React, { type JSX } from "react";
import { Avatar, CircularProgress } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";

export type OrganizationAvatarProps = Readonly<{
  logoUrl?: string | null;
  size?: number;
  isLoading?: boolean;
  ariaLabelLogo?: string;
  ariaLabelNoLogo?: string;
}>;

export function OrganizationAvatar({
  logoUrl,
  size = 40,
  isLoading = false,
  ariaLabelLogo = "Organization Logo",
  ariaLabelNoLogo = "Organization Icon",
}: OrganizationAvatarProps): JSX.Element {
  const [isLogoBroken, setIsLogoBroken] = React.useState(false);
  const showLogo = Boolean(logoUrl) && !isLogoBroken && !isLoading;

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontWeight: 700,
        backgroundColor: "#00000014",
      }}
      aria-label={showLogo ? ariaLabelLogo : ariaLabelNoLogo}
      aria-busy={isLoading}
      alt="Organization"
    >
      {isLoading ? (
        <CircularProgress
          size={Math.round(size * 0.6)}
          sx={{ color: "text.secondary" }}
        />
      ) : showLogo ? (
        <img
          src={logoUrl ?? ""}
          alt="Organization Logo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            objectPosition: "center",
          }}
          onError={() => setIsLogoBroken(true)}
        />
      ) : (
        <BusinessIcon
          sx={{
            fontSize: Math.round(size * 0.6),
            color: "text.secondary",
          }}
        />
      )}
    </Avatar>
  );
}

